import { ScavengerHunt } from "./ScavengerHunts";
import HS from "../img/Hugo_old.jpg";
import Head from "../img/head.jpg";

export const WintiGayesHalloween: ScavengerHunt = {
  title: "Die Legende von Hugo Salenstein und dem verlorenen Schatz",
  huntingText: (
    <>
      <h1>Die Legende von Hugo Salenstein und dem verlorenen Schatz</h1>
      <p>
        Vor vielen Jahren lebte ein Affe namens Hugo Salenstein. Er war ein
        geheimnisvoller und verschlagener Affe, der etwas unvorstellbar
        Kostbares in der Wohnung Winti-Gayes versteckte.
      </p>
      <img src={HS} />
      <p>
        Viele, die von diesem Schatz erfuhren, versuchten, die Rätsel zu lösen,
        die Hugo hinterlassen hatte, doch kaum einer kehrte je zurück.
        Diejenigen, die versuchten, die Geheimnisse zu lüften, fanden nichts als
        ihren Untergang.
      </p>
      <p>
        Hugo hinterliess eine Reihe von rätselhaften Hinweisen, die den Mutigen
        auf eine finstere Reise führen sollten. Es heisst, dass jene, die es
        wagen, seine Spuren zu folgen, einen schaurigen Pfad betreten – und nur
        wer alle Rätsel löst, kann das verborgene Geheimnis entdecken.
      </p>
      <hr />
      <p>
        Um den Schatz zu finden musst du die Rätsel lösen und an den beschrieben
        Orten einen Totenkopf finden! Diese Köpfe haben einen Zeichen auf der
        Stirn. Die Zeichen bilden den Code, welchen du unten eingeben musst, um
        das letzte Rätsel zu lösen.
      </p>
      <img src={Head} />
      <p>
        Versuche andere Spieler nicht zu spoilern oder zu sabotieren. Lass alle
        Rätsel und Totenköpfe da, wo sie sind. Falls nötig, kannst du ein Bild
        des Rätsels machen.
      </p>

      <p>Viel Spass und Glück wünschen dir Timon, Lauro und Nando!</p>
      <p>
        <b>Das erste Rätsel findest du hinter Nando's Tür.</b>
      </p>
    </>
  ),
  solutionCode: "7HQ5%T",
  congratsText: (
    <>
      <h2>🎃 Rätsel 7: Das Herz der Wohnung 🎃</h2>
      <p>
        <small>
          Du bist fast am Ende, es ist nicht mehr weit, <br />
          Doch der wahre Schatz liegt verborgen und bereit. <br />
          Gehe dorthin, wo das Zentrum ist, <br />
          Wo Ruhe herrscht und keine Gefahr mehr frisst. <br />
          <br />
          <br />
          Das Herz der Wohnung, ruhig und klar, <br />
          Dort findest du, was einst verloren war. <br />
          Ein Tisch steht dort, fest und still, <br />
          Darunter liegt das, was jeder will. <br />
          <br />
          <br />
          Doch bevor du den Schatz erblicken kannst, <br />
          Brauchst du den Schlüssel, den du schon erlangst. <br />
          Öffne damit, was verschlossen ruht, <br />
          Und finde das, was Hugo gut behüt’. <br />
          <br />
          <br />
          Grabe tief und suche gut, <br />
          Nur Mutige finden, was hier ruht. <br />
          Das Geheimnis, das Hugo einst bewahrt, <br />
          Wird dir gehören – wenn du’s wagst und es erfahrst. <br />
        </small>
        <br />
        <hr />
        <br />
        Mit dem Schlüssel, den du auf deiner Reise gesammelt hast, kannst du das
        letzte Rätsel öffnen und den wahren Schatz finden, den Hugo Salenstein
        vor allen verborgen hielt. <br />
        👑🗝️🎃 Viel Erfolg beim Entdecken des Schatzes!
      </p>
    </>
  ),
};
